import { generatePath } from "react-router-dom";

import { ROUTE_PATHS } from "../../../utils/RoutesPaths";

export const COMPANY_DETAILS_OVERVIEW_TAB = "overview";
export const COMPANY_DETAILS_CLIENTS_TAB = "clients";
export const COMPANY_DETAILS_TEAM_TAB = "teamPermissions";

export const TEAM_SUB_TABS = {
  employees: "employees",
  roles: "roles",
};

export const buildCompanyDetailsTabSearch = (tab, subtab) => {
  const params = new URLSearchParams({ tab });
  if (subtab) params.set("subtab", subtab);
  return `?${params.toString()}`;
};

export const resolveTeamSubtabFromSearch = (search) => {
  const subtab = new URLSearchParams(search).get("subtab");
  return subtab === TEAM_SUB_TABS.roles
    ? TEAM_SUB_TABS.roles
    : TEAM_SUB_TABS.employees;
};

export const adminCompanyTeamRoutes = {
  companyDetails: (companyId) =>
    generatePath(ROUTE_PATHS.companiesListCompanyDetails, { id: companyId }),

  companyDetailsTeamTab: (companyId, subtab = TEAM_SUB_TABS.employees) =>
    `${generatePath(ROUTE_PATHS.companiesListCompanyDetails, {
      id: companyId,
    })}${buildCompanyDetailsTabSearch(COMPANY_DETAILS_TEAM_TAB, subtab)}`,

  companyDetailsTabLocation: (
    companyId,
    tab = COMPANY_DETAILS_OVERVIEW_TAB,
    subtab,
  ) => ({
    pathname: generatePath(ROUTE_PATHS.companiesListCompanyDetails, {
      id: companyId,
    }),
    search: buildCompanyDetailsTabSearch(tab, subtab),
  }),

  employeeCreate: (companyId) =>
    generatePath(ROUTE_PATHS.adminCompanyTeamEmployeeCreate, { companyId }),

  employeeView: (companyId, employeeId) =>
    generatePath(ROUTE_PATHS.adminCompanyTeamEmployeeView, {
      companyId,
      id: employeeId,
    }),

  roleCreate: (companyId) =>
    generatePath(ROUTE_PATHS.adminCompanyTeamRoleCreate, { companyId }),

  roleView: (companyId, roleId) =>
    generatePath(ROUTE_PATHS.adminCompanyTeamRoleView, {
      companyId,
      id: roleId,
    }),
};
